import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, LinkedinIcon } from 'lucide-react';
import { profile } from '../data/profile';
export function Hero() {
  return <section id="top" className="relative w-full overflow-hidden border-b-2 border-gold bg-ocean" aria-labelledby="hero-heading" data-id="element-87" data-mp="9ktfls818azv">
      <div className="institutional-grid absolute inset-0" aria-hidden="true" data-id="element-88" data-mp="4n9z0lnv3m4r" />

      <div className="relative mx-auto grid w-full max-w-7xl grid-cols-1 items-center gap-14 px-6 py-16 lg:grid-cols-[1fr_auto] lg:gap-20 lg:px-10 lg:py-24" data-id="element-89" data-mp="128fsjr35grze">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-90" data-mp="sbb0jammi2ao">
          <div className="flex items-center gap-3" data-id="element-91" data-mp="neavn31if5l5">
            <span className="h-[2px] w-10 bg-gold" aria-hidden="true" data-id="element-92" data-mp="3d2lapfhgtb2a" />
            <p className="font-display text-[11px] font-bold uppercase tracking-[0.24em] text-gold-soft" data-id="element-93" data-mp="382p4rap7j9k3">
              {profile.name}
            </p>
          </div>

          <h1 id="hero-heading" className="mt-6 font-display text-4xl font-extrabold leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-[3.4rem]" data-id="element-94" data-mp="3j6fxfnpbn9cs">
            {profile.headline.map(part => <span key={part} className="block" data-id="element-95" data-mp="3e8wjkowjcyld">
                {part}
              </span>)}
          </h1>

          <p className="mt-6 max-w-xl text-base leading-relaxed text-white/75 sm:text-lg" data-id="element-96" data-mp="30gzteqefgyrm">
            {profile.subheadline}
          </p>

          <ul className="mt-8 flex flex-wrap gap-3" aria-label="Credentials" data-id="element-97" data-mp="35au9ljutqvly">
            {profile.badges.map(badge => <li key={badge} className="border border-white/25 px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.16em] text-white" data-id="element-98" data-mp="2viokchvyisag">
                <span className="mr-2 inline-block h-1.5 w-1.5 -translate-y-[1px] bg-gold align-middle" data-id="element-99" data-mp="2lkqx9xpu31jf" />
                {badge}
              </li>)}
          </ul>

          <div className="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center" data-id="element-100" data-mp="s44j7qwfvrjh">
            <a href="#contact" className="group inline-flex items-center justify-center gap-3 border border-gold bg-gold px-7 py-4 font-display text-xs font-bold uppercase tracking-[0.18em] text-ocean-deep transition-colors hover:bg-gold-soft" data-id="element-101" data-mp="n9qeuyzsua2o">
              Executive Resume / Bio
              <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-1" data-id="element-102" data-mp="1ayjiziqkro8d" />
            </a>
            <a href={profile.linkedin} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 border border-white/30 px-7 py-4 font-display text-xs font-bold uppercase tracking-[0.18em] text-white transition-colors hover:border-white hover:bg-white/5" data-id="element-103" data-mp="112pzffefuuh3">
              <LinkedinIcon className="h-4 w-4" data-id="element-104" data-mp="3hq25sw90g49b" />
              Connect on LinkedIn
            </a>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.94
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.1,
        ease: [0.22, 1, 0.36, 1]
      }} className="mx-auto" data-id="element-105" data-mp="21amw19r97smc">
          <div className="relative rounded-full border-2 border-gold/30 p-3 sm:p-4" data-id="element-106" data-mp="2b1r923xdd3ej">
            <div className="rounded-full border-[3px] border-gold p-1.5" data-id="element-107" data-mp="2g0ls96z90tz6">
              <img src={profile.portrait} alt={`Portrait of ${profile.name}`} className="h-56 w-56 rounded-full object-cover object-center sm:h-72 sm:w-72 lg:h-[24rem] lg:w-[24rem]" data-id="element-108" data-mp="2kyvqjqg9sap0" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}